import { BaseExtension } from '../utils';
export class BaseTransport extends BaseExtension {
    getIgnoreUrls() {
        return [];
    }
}
//# sourceMappingURL=base.js.map